import moment from "moment-timezone";
import { useEffect, useState } from "react";

export const useCountdown = (targetDate, isSeconds, showSeconds) => {
  const formattedDate = isSeconds ? targetDate * 1000 : targetDate;

  //running in milliseconds
  const countDownDate = moment(formattedDate).valueOf();

  const [countDown, setCountDown] = useState(
    countDownDate - moment().valueOf(),
  );

  useEffect(() => {
    const repInterval = showSeconds ? 1000 : 60000;
    const interval = setInterval(() => {
      setCountDown(countDownDate - moment().valueOf());
    }, repInterval);

    return () => clearInterval(interval);
  }, [countDownDate, showSeconds]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(countDown / (1000 * 60 * 60));
  const mins = Math.floor(countDown / (1000 * 60));
  const secs = Math.floor(countDown / 1000);

  const dd = days;
  const hh = hours - days * 24;
  const mm = mins - hours * 60;
  const ss = secs - mins * 60;

  return [dd, hh, mm, ss.toString()];
};
